"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as i, jsx as e } from "react/jsx-runtime";
import { useTheme as n } from "../../hooks.js";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const m = (_param)=>{
    var { color: r, size: c = 24 } = _param, t = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const h = s(), l = r !== null && r !== void 0 ? r : h ? o.colors.inverse : o.colors.neutralHigh, { skinName: a } = n();
    return a.match(/^blau/i) ? /* @__PURE__ */ i("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: [
            /* @__PURE__ */ e("path", {
                fill: l,
                d: "M12 15.214a.716.716 0 0 1-.714-.714c0-1.179.464-2.286 1.285-3.143l1.036-1.036c.393-.392.322-1.285 0-1.714a1.81 1.81 0 0 0-1.428-.714H12c-.571 0-1.107.321-1.393.786-.214.357-.643.464-.964.25-.357-.215-.464-.643-.25-.965A3.01 3.01 0 0 1 12 6.464h.179c1 0 1.928.465 2.535 1.25.715.929.822 2.643-.107 3.607l-1.036 1.036c-.535.607-.857 1.357-.857 2.143a.716.716 0 0 1-.714.714M12 17.607a.786.786 0 1 0 0-1.571.786.786 0 0 0 0 1.571"
            }),
            /* @__PURE__ */ e("path", {
                fill: l,
                d: "M2 12c0 5.5 4.5 10 10 10s10-4.5 10-10S17.5 2 12 2 2 6.5 2 12m1.429 0c0-4.714 3.857-8.571 8.571-8.571S20.571 7.286 20.571 12 16.714 20.571 12 20.571 3.429 16.714 3.429 12"
            })
        ]
    })) : a.match(/^o2-new/i) ? /* @__PURE__ */ i("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: [
            /* @__PURE__ */ e("path", {
                fill: l,
                d: "M12 15.216a.72.72 0 0 1-.716-.716c0-1.18.464-2.284 1.284-3.144l1.036-1.036c.392-.392.32-1.284 0-1.716a1.81 1.81 0 0 0-1.428-.716H12c-.572 0-1.108.32-1.392.784-.216.356-.644.464-.964.252-.356-.216-.464-.644-.252-.964A3.02 3.02 0 0 1 12 6.46h.18c1 0 1.928.464 2.536 1.252.716.928.82 2.644-.108 3.608l-1.036 1.036c-.536.608-.856 1.356-.856 2.144a.72.72 0 0 1-.716.716M12.784 16.82a.784.784 0 1 1-1.568 0 .784.784 0 0 1 1.568 0"
            }),
            /* @__PURE__ */ e("path", {
                fill: l,
                d: "M12 22C6.5 22 2 17.5 2 12S6.5 2 12 2s10 4.5 10 10-4.5 10-10 10m0-18.572c-4.716 0-8.572 3.856-8.572 8.572S7.284 20.572 12 20.572s8.572-3.856 8.572-8.572S16.716 3.428 12 3.428"
            })
        ]
    })) : a.match(/^o2/i) ? /* @__PURE__ */ i("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: [
            /* @__PURE__ */ e("path", {
                fill: l,
                d: "M12 15.216a.72.72 0 0 1-.716-.716c0-1.18.464-2.284 1.284-3.144l1.036-1.036c.392-.392.32-1.284 0-1.716a1.81 1.81 0 0 0-1.428-.716H12c-.572 0-1.108.32-1.392.784-.216.356-.644.464-.964.252-.356-.216-.464-.644-.252-.964A3.02 3.02 0 0 1 12 6.46h.18c1 0 1.928.464 2.536 1.252.716.928.82 2.644-.108 3.608l-1.036 1.036c-.536.608-.856 1.356-.856 2.144a.72.72 0 0 1-.716.716M12.784 16.82a.784.784 0 1 1-1.568 0 .784.784 0 0 1 1.568 0"
            }),
            /* @__PURE__ */ e("path", {
                fill: l,
                d: "M12 22C6.5 22 2 17.5 2 12S6.5 2 12 2s10 4.5 10 10-4.5 10-10 10m0-18.572c-4.716 0-8.572 3.856-8.572 8.572S7.284 20.572 12 20.572s8.572-3.856 8.572-8.572S16.716 3.428 12 3.428"
            })
        ]
    })) : /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: /* @__PURE__ */ e("path", {
            fill: l,
            d: "M23 12.028C23 1.782 14.21 1.053 12.448 1.012c-.307-.01-.673-.016-.999-.01C9.702 1.019 1 1.613 1 11.969s8.762 11.006 10.518 11.028q.156.004.316.003c.225 0 .454-.003.648-.006C14.242 22.962 23 22.283 23 12.028m-1.345 0c0 8.772-7.037 9.58-9.194 9.62a22 22 0 0 1-.923.006c-2.157-.031-9.191-.82-9.191-9.685 0-8.856 6.974-9.6 9.112-9.623.316-.003.664.003.958.01 2.166.053 9.238.904 9.238 9.673m-10.147 5.058c.592 0 .977.388.977.946 0 .622-.379.995-.942.995-.601 0-.977-.373-.977-.923v-.072c.003-.558.388-.946.942-.946M15.61 8.34c0-1.127-.366-1.92-1.146-2.495-.607-.46-1.446-.692-2.497-.689-1 0-2.035.207-2.458.407a.45.45 0 0 0-.247.488l.072.382.003.014.003.015a.45.45 0 0 0 .545.322 7.2 7.2 0 0 1 1.862-.244c1.156 0 1.578.222 1.82.413.419.335.597.742.597 1.365 0 .876-.297 1.396-1.869 3.255l-.181.22c-.955 1.148-1.38 1.865-1.38 3.077a3.6 3.6 0 0 0 .062.707.45.45 0 0 0 .441.363h.495c.247 0 .447-.2.447-.447 0-1.616.06-1.684 1.556-3.416 1.306-1.54 1.875-2.36 1.875-3.737"
        })
    }));
}, v = m;
export { v as default };
